module.exports = __webpack_public_path__ + "img/eu15.bb98f456.svg";